/**
 * ARCA Official Color Scheme
 * Africa Respiratory Care Association
 * Official Brand Colors
 */
export const ARCA_COLORS = {
    // Primary Brand Colors
    primary: '#6B8E23',      // Primary Green
    primaryDark: '#58761C',  // Primary Green Dark
    primaryLight: '#7FA02E', // Primary Green Light

    // Neutral Colors
    dark: '#4A4F4F',         // Dark Gray
    light: '#A0A5A5',        // Light Gray
    textBlack: '#1C1C1C',    // Text Black
    white: '#FFFFFF',        // White
    backgroundLight: '#F5F5F5', // Background Light

    // Semantic Colors
    success: '#6B8E23',      // Success (same as primary green)
    danger: '#C62828',       // Danger Red
    warning: '#F57C00',      // Warning Orange
    info: '#4A4F4F'          // Info (same as dark gray)
};
